module.exports = __webpack_public_path__ + "media/src/StayPackage/images/info-e90bfd67b3c860d0ea6e7a6edf8a8c65.svg";